import { render, staticRenderFns } from "./CarrierProduct.vue?vue&type=template&id=58ad879c"
import script from "./CarrierProduct.vue?vue&type=script&lang=js"
export * from "./CarrierProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports